// Used to determine the child mapper mapping direction in the CombinedPortfoliosGridExtractorConfig
export enum ChildMapperDirection {
	ParentToChild, // The traditional direction. Will add parent info to child cells
	ChildToParent // Will add child info to parent cells
}
